import { render, staticRenderFns } from "./WsInfoWasaIntro.vue?vue&type=template&id=c53010bc&"
import script from "./WsInfoWasaIntro.vue?vue&type=script&lang=js&"
export * from "./WsInfoWasaIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports